import { render } from "./CreateProductTransfer.vue?vue&type=template&id=52098205&scoped=true"
import script from "./CreateProductTransfer.vue?vue&type=script&lang=js"
export * from "./CreateProductTransfer.vue?vue&type=script&lang=js"

import "./CreateProductTransfer.vue?vue&type=style&index=0&id=52098205&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52098205"]])

export default __exports__